
import {onMounted, reactive, ref} from 'vue';
import HotspotPopup from './hotspotPopup.vue';
import {GetHotspotFeaturedImage, GetHotspotItems} from 'Apis/apis';

export default {
	name: 'HotspotDesktop',
	components: {
		HotspotPopup,
	},
	setup() {
		const featuredImage = ref('');
		const hotspotItems = ref([]);
		const fallbackImage = ref('/ResourcePackages/RoyalPrestige/assets/src/project/images/Misc/noimage.jpg');
		const title = ref({});
		let titleLn = document.querySelector('.hotspot').getAttribute('data-title').length == 0 ? 0 : document.querySelector('.hotspot').getAttribute('data-title').length;

		let hotspotId = document.querySelector('.hotspot').getAttribute('data-hotspotId') ? document.querySelector('.hotspot').getAttribute('data-hotspotId') : "";

		async function getHotspotFeaturedImage(hotspotId) {
			const rsp = await GetHotspotFeaturedImage(hotspotId);
			if (rsp.value) {
				featuredImage.value = rsp.value[0]?.Url;
			}
		}

		let showItem = (item) => {
			item.visible = !item.visible;
		};

		let hideItem = (item) => {
			hotspotItems.value.forEach((hotspotItem) => {
				hotspotItem.visible = false;
			});
		};

		async function getHotspotItems(hotspotId) {
			const items = await GetHotspotItems(hotspotId);
			if (items.value) {
				hotspotItems.value = items.value.map(item => ({...item, visible: false}));
			}
		}

		onMounted(() => {
			const titleEl = document.querySelector('.hotspot');
			const titleValue = titleEl.getAttribute('data-title');
			
			if (titleEl && titleValue) {
				title.value = titleValue;				
			}
			getHotspotFeaturedImage(hotspotId);
			getHotspotItems(hotspotId);
		});

		return {
			featuredImage,
			hotspotId,
			hotspotItems,
			showItem,
			hideItem,
			fallbackImage,
			title,
			titleLn
		};
	},
};
